import { html, Page } from 'rune-ts';
import klass from './plus_content_list.module.scss';
import { LayoutView } from '../../components/cells/Layout/LayoutView';
import { footer_links } from '../../components/cells/Footer/constant';

import { PlusCommonTmplS } from '../../../../../modules/Plus/Common/S/Tmpl/module/PlusCommonTmplS';
import { PlusContent, PlusContentCard } from '../../components/cells/PlusContentCard/PlusContentCard';
import { BaseLayoutOptions } from '../../../features/Core/service';
import { SubHeaderMobile } from '../../components/cells/Header/Global/views/SubHeaderMobile.ts';
import { SectionTitle } from '@services/MarppleShop/renderApp/components/cells/SectionTitle/SectionTitle.ts';

export interface PlusContentListData {
  contents: PlusContent[];
  layout_options: BaseLayoutOptions;
}

export class PlusContentListPage extends Page<PlusContentListData> {
  override onMount() {
    try {
      SubHeaderMobile.handleChangeMenuOutside();
    } catch (err) {
      console.log(err);
    }
  }

  protected override template() {
    const { contents, layout_options } = this.data;
    const { is_mobile } = layout_options;

    const texts = {
      title: ET('mps2::plus::content'),
      h2: ET('mps2::contents::list_description'),
    };

    const body = html`
      <div class="${klass.body}">
        ${new SectionTitle({
          title_props: {
            title: texts.title,
            sub_title: texts.h2,
            size: is_mobile ? 'large' : 'xLarge',
          },
        })}
        <div class="${klass.content_list}">
          ${contents.map((content) => new PlusContentCard({ content }, { not_lazy: true, is_mobile }))}
        </div>
        ${contents.length == 0
          ? html`<div>${html.preventEscape(PlusCommonTmplS.makeEmptyPlusContentsPage())}</div>`
          : ''}
      </div>
    `;

    return html`
      <div class="${klass.plus_content_list_page}">
        ${new LayoutView(
          {
            body,
            footer_data: { ...footer_links, lang: ET.lang, is_mobile },
          },
          {
            require_top_arrow_button: false,
            full_width: false,
            has_bottom_tab_bar: true,
            selected_bottom_tab_idx: -1,
            ...layout_options,
          },
        )}
      </div>
    `;
  }
}
